import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import './landingSection.css';
import './landingSectionMobile.css';

const LandingSection = (props) => {
  const pageContent = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];

  return <section className="landing" id="landing">
    <div className="logo"><img src={logoUrl} /></div>
    {pageContent['introduction'].map((content, idx) => {
      return <div key={idx}
        className={`introduction verticalText ${content['language']} ${content['language'] === currentLanguage? 'mobile': ''}`}
        dangerouslySetInnerHTML={{
          __html: content['text']
      }} />;
    })}
    <div className="decorateLine" />
    <div className="scrollHints" dangerouslySetInnerHTML={{
      __html: pageContent['scrollHints']
    }} />
    <div className="coverMedia">
    {/* https://www.robinwieruch.de/conditional-rendering-react */}
    {{
      image: <img src={pageContent['cover']['src']} />,
      video: <video src={pageContent['cover']['src']} autoPlay muted playsInline loop />,
    }[pageContent['cover']['type']]}
    </div>
  </section>;
}

export default LandingSection;